import { __read, __values } from "tslib";
import { appendQueryParams } from '@office-start/url-parser-utility';
import { Host } from './Host';
// Copilot routing utilities
var ocdiBaseUrlDefault = 'https://m365.cloud.microsoft';
var ccmBaseUrlDefault = 'https://copilot.cloud.microsoft';
export function routeToCopilotStandalone(isUserInCopilotStandalone, copilotBaseUrl, identity) {
    if (!isUserInCopilotStandalone) {
        var baseUrl = copilotBaseUrl !== null && copilotBaseUrl !== void 0 ? copilotBaseUrl : ccmBaseUrlDefault;
        var newPath = '/';
        routeToUrl(baseUrl, newPath, identity);
        return true;
    }
    return false;
}
export function routeToOCDIChat(isUserInCopilotStandalone, copilotBaseUrl, identity, copilotRedirectControlEnabled) {
    var newPath = '/chat';
    var baseUrl = copilotBaseUrl !== null && copilotBaseUrl !== void 0 ? copilotBaseUrl : ocdiBaseUrlDefault;
    if (!shouldBlockRedirection(isUserInCopilotStandalone, copilotRedirectControlEnabled !== null && copilotRedirectControlEnabled !== void 0 ? copilotRedirectControlEnabled : false) &&
        (isUserInCopilotStandalone || !isUserInOCDIChat(baseUrl, newPath))) {
        routeToUrl(baseUrl, newPath, identity);
        return true;
    }
    return false;
}
function isUserInOCDIChat(baseUrl, chatPath) {
    var currentUrl = window.location.origin + window.location.pathname;
    if (currentUrl === "".concat(baseUrl).concat(chatPath) ||
        currentUrl === "".concat(baseUrl).concat(chatPath, "/")) {
        return true;
    }
    return false;
}
function routeToUrl(baseUrl, path, identity) {
    var searchParams = new URLSearchParams(location.search);
    var newUrl = "".concat(baseUrl).concat(path, "?").concat(searchParams.toString());
    var loginHintParam = {
        login_hint: identity === null || identity === void 0 ? void 0 : identity.userPrincipalName,
    };
    var redirectionUrl = appendQueryParams(newUrl, loginHintParam);
    // calling window.location.href to ensure that a service call is made while routing
    window.location.href = redirectionUrl;
}
function shouldBlockRedirection(isUserInCopilotStandalone, copilotRedirectControlEnabled) {
    if (!copilotRedirectControlEnabled || !isUserInCopilotStandalone) {
        return false;
    }
    var searchParams = new URLSearchParams(location.search);
    var referrerCode = getCaseInsensitiveParam(searchParams, 'internalredirect');
    if (isValidReferrerCode(referrerCode)) {
        return true;
    }
    return false;
}
function getCaseInsensitiveParam(searchParams, param) {
    var e_1, _a;
    if (!searchParams) {
        return null;
    }
    try {
        for (var _b = __values(searchParams.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (key.toLowerCase() === param.toLowerCase()) {
                return value.toLowerCase();
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
function isValidReferrerCode(referrerCode) {
    if (!referrerCode)
        return false;
    var lowerCaseReferrerCode = referrerCode.toLowerCase();
    var validHosts = Object.values(Host).map(function (value) { return value.toLowerCase(); });
    return (validHosts.includes(lowerCaseReferrerCode) &&
        lowerCaseReferrerCode !== Host.Other.toLowerCase());
}
//# sourceMappingURL=copilotRoutingUtilities.js.map